import { client } from './client'

// ─── Types ─────────────────────────────────────────────────────────────

export interface Notification {
  id: string
  type: string
  title: string
  body: string | null
  is_read: boolean
  related_type: string | null
  related_id: string | null
  created_at: string
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

// ─── API ───────────────────────────────────────────────────────────────

export async function listNotifications(params?: {
  is_read?: boolean
  page?: number
  page_size?: number
}): Promise<PaginatedResponse<Notification>> {
  const query = new URLSearchParams()
  if (params?.is_read !== undefined) query.set('is_read', String(params.is_read))
  if (params?.page) query.set('page', String(params.page))
  if (params?.page_size) query.set('page_size', String(params.page_size))
  const qs = query.toString()
  return client.get<PaginatedResponse<Notification>>(`/notifications${qs ? `?${qs}` : ''}`)
}

export async function getUnreadCount(): Promise<{ count: number }> {
  return client.get<{ count: number }>('/notifications/unread-count')
}

export async function markAsRead(id: string): Promise<Notification> {
  return client.put<Notification>(`/notifications/${id}/read`, {})
}

export async function markAllAsRead(): Promise<{ marked_count: number }> {
  return client.put<{ marked_count: number }>('/notifications/read-all', {})
}
